import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: "fortune-tools",
  name: "命盘工具",
  icon: "盘",
  group: "国学组件",
  description: "八字四柱、紫微斗数、奇门遁甲、每日运势等工具集合。",
  defaultProps: {
    "title": "命盘工具",
    "limit": 6
}
}
